// Extended property data with all languages and new sections
export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'gr', name: 'Ελληνικά', flag: '🇬🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'he', name: 'עברית', flag: '🇮🇱' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' }
];

export const propertyHighlights = {
  en: {
    title: 'Property Highlights',
    items: [
      { text: 'Two independent traditional cottage houses', icon: 'Home' },
      { text: 'Approx. 8,000 sqm private land', icon: 'Map' },
      { text: 'Unobstructed sea views', icon: 'Eye' },
      { text: 'Views towards Skiathos & Alonissos', icon: 'Mountain' },
      { text: 'Quiet natural surroundings & privacy', icon: 'Trees' },
      { text: 'Ideal for private use or rental investment', icon: 'TrendingUp' }
    ]
  },
  gr: {
    title: 'Χαρακτηριστικά Ακινήτου',
    items: [
      { text: 'Δύο ανεξάρτητα παραδοσιακά εξοχικά', icon: 'Home' },
      { text: 'Περίπου 8.000 τ.μ. ιδιωτική γη', icon: 'Map' },
      { text: 'Απρόσκοπτη θέα θάλασσα', icon: 'Eye' },
      { text: 'Θέα προς Σκιάθο & Αλόννησο', icon: 'Mountain' },
      { text: 'Ήσυχο φυσικό περιβάλλον & ιδιωτικότητα', icon: 'Trees' },
      { text: 'Ιδανικό για ιδιωτική χρήση ή ενοικίαση', icon: 'TrendingUp' }
    ]
  },
  de: {
    title: 'Immobilien-Highlights',
    items: [
      { text: 'Zwei unabhängige traditionelle Ferienhäuser', icon: 'Home' },
      { text: 'Ca. 8.000 qm Privatgrundstück', icon: 'Map' },
      { text: 'Unverbaubarer Meerblick', icon: 'Eye' },
      { text: 'Blick auf Skiathos & Alonissos', icon: 'Mountain' },
      { text: 'Ruhige natürliche Umgebung & Privatsphäre', icon: 'Trees' },
      { text: 'Ideal für Privatnutzung oder Vermietung', icon: 'TrendingUp' }
    ]
  },
  he: {
    title: 'עיקרי הנכס',
    items: [
      { text: 'שני בתי נופש מסורתיים עצמאיים', icon: 'Home' },
      { text: 'כ-8,000 מ"ר קרקע פרטית', icon: 'Map' },
      { text: 'נוף ים בלתי מוגבל', icon: 'Eye' },
      { text: 'נוף לסקיאתוס ואלוניסוס', icon: 'Mountain' },
      { text: 'סביבה טבעית שקטה ופרטיות', icon: 'Trees' },
      { text: 'אידיאלי לשימוש פרטי או השכרה', icon: 'TrendingUp' }
    ]
  },
  fr: {
    title: 'Points Forts de la Propriété',
    items: [
      { text: 'Deux maisons de vacances traditionnelles indépendantes', icon: 'Home' },
      { text: 'Environ 8 000 m² de terrain privé', icon: 'Map' },
      { text: 'Vues mer dégagées', icon: 'Eye' },
      { text: 'Vue vers Skiathos et Alonissos', icon: 'Mountain' },
      { text: 'Environnement naturel calme et intimité', icon: 'Trees' },
      { text: 'Idéal pour usage privé ou investissement locatif', icon: 'TrendingUp' }
    ]
  },
  zh: {
    title: '房产亮点',
    items: [
      { text: '两栋独立传统小屋', icon: 'Home' },
      { text: '约8,000平方米私人土地', icon: 'Map' },
      { text: '无遮挡海景', icon: 'Eye' },
      { text: '眺望斯基亚索斯和阿洛尼索斯', icon: 'Mountain' },
      { text: '安静的自然环境与隐私', icon: 'Trees' },
      { text: '适合私人使用或租赁投资', icon: 'TrendingUp' }
    ]
  },
  ar: {
    title: 'مميزات العقار',
    items: [
      { text: 'منزلان ريفيان تقليديان مستقلان', icon: 'Home' },
      { text: 'حوالي 8000 متر مربع أرض خاصة', icon: 'Map' },
      { text: 'إطلالات بحرية غير محجوبة', icon: 'Eye' },
      { text: 'إطلالة نحو سكياثوس وألونيسوس', icon: 'Mountain' },
      { text: 'محيط طبيعي هادئ وخصوصية', icon: 'Trees' },
      { text: 'مثالي للاستخدام الخاص أو الاستثمار الإيجاري', icon: 'TrendingUp' }
    ]
  },
  ru: {
    title: 'Основные Характеристики',
    items: [
      { text: 'Два независимых традиционных коттеджа', icon: 'Home' },
      { text: 'Около 8 000 кв.м частной земли', icon: 'Map' },
      { text: 'Беспрепятственный вид на море', icon: 'Eye' },
      { text: 'Вид на Скиатос и Алониссос', icon: 'Mountain' },
      { text: 'Тихая природная обстановка и приватность', icon: 'Trees' },
      { text: 'Идеально для личного пользования или аренды', icon: 'TrendingUp' }
    ]
  }
};

export const whyUnique = {
  en: {
    title: 'Why This Property Is Unique',
    text: 'Properties offering this combination of large land size, unobstructed sea views, and authentic cottage houses are increasingly rare on Skopelos. The privacy, open views towards Skiathos and Alonissos, and the natural surroundings make this property suitable both as a personal retreat and as a long-term investment.'
  },
  gr: {
    title: 'Γιατί Αυτό το Ακίνητο Είναι Μοναδικό',
    text: 'Ακίνητα που προσφέρουν αυτόν τον συνδυασμό μεγάλης έκτασης, απρόσκοπτης θέας θάλασσας και αυθεντικών παραδοσιακών σπιτιών γίνονται όλο και πιο σπάνια στη Σκόπελο. Η ιδιωτικότητα, η ανοιχτή θέα προς Σκιάθο και Αλόννησο, και το φυσικό περιβάλλον κάνουν το ακίνητο κατάλληλο τόσο ως προσωπικό καταφύγιο όσο και ως μακροπρόθεσμη επένδυση.'
  },
  de: {
    title: 'Warum Diese Immobilie Einzigartig Ist',
    text: 'Immobilien mit dieser Kombination aus großer Grundstücksfläche, unverbaubarem Meerblick und authentischen Cottages werden auf Skopelos immer seltener. Die Privatsphäre, der freie Blick auf Skiathos und Alonissos sowie die natürliche Umgebung machen diese Immobilie sowohl als persönlichen Rückzugsort als auch als langfristige Investition geeignet.'
  },
  he: {
    title: 'למה הנכס הזה ייחודי',
    text: 'נכסים המציעים שילוב זה של שטח קרקע גדול, נוף ים בלתי מוגבל ובתים מסורתיים אותנטיים הופכים נדירים יותר ויותר בסקופלוס. הפרטיות, הנוף הפתוח לסקיאתוס ואלוניסוס, והסביבה הטבעית הופכים את הנכס למתאים הן כמקום מפלט אישי והן כהשקעה ארוכת טווח.'
  },
  fr: {
    title: 'Pourquoi Cette Propriété Est Unique',
    text: 'Les propriétés offrant cette combinaison de grande superficie, de vues mer dégagées et de maisons traditionnelles authentiques deviennent de plus en plus rares à Skopelos. L\'intimité, les vues ouvertes vers Skiathos et Alonissos, et l\'environnement naturel rendent cette propriété adaptée à la fois comme retraite personnelle et comme investissement à long terme.'
  },
  zh: {
    title: '为什么这处房产如此独特',
    text: '在斯科派洛斯，同时拥有大片土地、无遮挡海景和正宗传统小屋的房产正变得越来越稀有。隐私性、面向斯基亚索斯和阿洛尼索斯的开阔视野，以及自然环境，使这处房产既适合作为个人度假胜地，也适合作为长期投资。'
  },
  ar: {
    title: 'لماذا هذا العقار فريد من نوعه',
    text: 'العقارات التي تقدم هذا المزيج من مساحة الأرض الكبيرة والإطلالات البحرية غير المحجوبة والمنازل الريفية الأصيلة أصبحت نادرة بشكل متزايد في سكوبيلوس. الخصوصية والإطلالات المفتوحة نحو سكياثوس وألونيسوس والمحيط الطبيعي تجعل هذا العقار مناسباً كملاذ شخصي وكاستثمار طويل الأجل.'
  },
  ru: {
    title: 'Почему Эта Недвижимость Уникальна',
    text: 'Недвижимость, предлагающая такое сочетание большой площади земли, беспрепятственного вида на море и аутентичных коттеджей, становится все более редкой на Скопелосе. Приватность, открытые виды на Скиатос и Алониссос, а также природное окружение делают эту недвижимость подходящей как для личного убежища, так и для долгосрочных инвестиций.'
  }
};

export const locationDetails = {
  en: {
    title: 'Location & Distances',
    distances: [
      { label: 'Glossa village (nearest)', value: '3 minutes' },
      { label: 'Loutraki port', value: '5 minutes' },
      { label: 'Nearest beach (Perivoliou)', value: '8 minutes' },
      { label: 'Skopelos town', value: '25 minutes' },
      { label: 'Supermarket (Glossa)', value: '3 minutes' },
      { label: 'Skopelos port', value: '30 minutes' }
    ]
  },
  gr: {
    title: 'Τοποθεσία & Αποστάσεις',
    distances: [
      { label: 'Γλώσσα (πλησιέστερο χωριό)', value: '3 λεπτά' },
      { label: 'Λιμάνι Λουτρακίου', value: '5 λεπτά' },
      { label: 'Κοντινότερη παραλία (Περιβολιού)', value: '8 λεπτά' },
      { label: 'Χώρα Σκοπέλου', value: '25 λεπτά' },
      { label: 'Σούπερ μάρκετ (Γλώσσα)', value: '3 λεπτά' },
      { label: 'Λιμάνι Σκοπέλου', value: '30 λεπτά' }
    ]
  },
  de: {
    title: 'Lage & Entfernungen',
    distances: [
      { label: 'Glossa Dorf (nächstes)', value: '3 Minuten' },
      { label: 'Loutraki Hafen', value: '5 Minuten' },
      { label: 'Nächster Strand (Perivoliou)', value: '8 Minuten' },
      { label: 'Skopelos-Stadt', value: '25 Minuten' },
      { label: 'Supermarkt (Glossa)', value: '3 Minuten' },
      { label: 'Skopelos Hafen', value: '30 Minuten' }
    ]
  },
  he: {
    title: 'מיקום ומרחקים',
    distances: [
      { label: 'כפר גלוסה (הקרוב ביותר)', value: '3 דקות' },
      { label: 'נמל לוטראקי', value: '5 דקות' },
      { label: 'חוף הקרוב (פריבוליו)', value: '8 דקות' },
      { label: 'עיר סקופלוס', value: '25 דקות' },
      { label: 'סופרמרקט (גלוסה)', value: '3 דקות' },
      { label: 'נמל סקופלוס', value: '30 דקות' }
    ]
  },
  fr: {
    title: 'Emplacement & Distances',
    distances: [
      { label: 'Village de Glossa (plus proche)', value: '3 minutes' },
      { label: 'Port de Loutraki', value: '5 minutes' },
      { label: 'Plage la plus proche (Perivoliou)', value: '8 minutes' },
      { label: 'Ville de Skopelos', value: '25 minutes' },
      { label: 'Supermarché (Glossa)', value: '3 minutes' },
      { label: 'Port de Skopelos', value: '30 minutes' }
    ]
  },
  zh: {
    title: '位置与距离',
    distances: [
      { label: '格洛萨村（最近）', value: '3分钟' },
      { label: '卢特拉基港', value: '5分钟' },
      { label: '最近海滩（佩里沃利乌）', value: '8分钟' },
      { label: '斯科派洛斯镇', value: '25分钟' },
      { label: '超市（格洛萨）', value: '3分钟' },
      { label: '斯科派洛斯港', value: '30分钟' }
    ]
  },
  ar: {
    title: 'الموقع والمسافات',
    distances: [
      { label: 'قرية غلوسا (الأقرب)', value: '3 دقائق' },
      { label: 'ميناء لوتراكي', value: '5 دقائق' },
      { label: 'أقرب شاطئ (بيريفوليو)', value: '8 دقائق' },
      { label: 'مدينة سكوبيلوس', value: '25 دقيقة' },
      { label: 'سوبرماركت (غلوسا)', value: '3 دقائق' },
      { label: 'ميناء سكوبيلوس', value: '30 دقيقة' }
    ]
  },
  ru: {
    title: 'Расположение и Расстояния',
    distances: [
      { label: 'Деревня Глосса (ближайшая)', value: '3 минуты' },
      { label: 'Порт Лутраки', value: '5 минут' },
      { label: 'Ближайший пляж (Периволиу)', value: '8 минут' },
      { label: 'Город Скопелос', value: '25 минут' },
      { label: 'Супермаркет (Глосса)', value: '3 минуты' },
      { label: 'Порт Скопелос', value: '30 минут' }
    ]
  }
};

export const galleryCategories = {
  en: ['Exterior views', 'Arrival & surroundings', 'Sea & island views', 'Cottage interiors', 'Outdoor living areas'],
  gr: ['Εξωτερικές όψεις', 'Άφιξη & περιβάλλοντας', 'Θέα θάλασσας & νησιών', 'Εσωτερικοί χώροι', 'Υπαίθριοι χώροι'],
  de: ['Außenansichten', 'Ankunft & Umgebung', 'Meer- & Inselblick', 'Cottage-Innenräume', 'Außenwohnbereiche'],
  he: ['נופים חיצוניים', 'הגעה וסביבה', 'נוף ים ואיים', 'פנים הקוטג\'ים', 'אזורי מגורים חיצוניים'],
  fr: ['Vues extérieures', 'Arrivée et environs', 'Vues mer & îles', 'Intérieurs des cottages', 'Espaces de vie extérieurs'],
  zh: ['外观', '到达与周边', '海景与岛屿', '小屋内部', '户外生活区'],
  ar: ['المناظر الخارجية', 'الوصول والمحيط', 'إطلالات البحر والجزر', 'داخل الأكواخ', 'مناطق المعيشة الخارجية'],
  ru: ['Внешний вид', 'Подъезд и окрестности', 'Виды на море и острова', 'Интерьеры коттеджей', 'Открытые жилые зоны']
};

export const potentialUses = {
  en: {
    title: 'Potential Uses',
    uses: [
      'Private holiday residence',
      'Family summer retreat',
      'Boutique rental cottages',
      'Long-term investment property'
    ]
  },
  gr: {
    title: 'Δυνατότητες Χρήσης',
    uses: [
      'Ιδιωτική εξοχική κατοικία',
      'Οικογενειακό καταφύγιο καλοκαιριού',
      'Boutique ενοικιαζόμενα',
      'Μακροπρόθεσμη επενδυτική ιδιοκτησία'
    ]
  },
  de: {
    title: 'Nutzungsmöglichkeiten',
    uses: [
      'Private Ferienresidenz',
      'Familiensommerhaus',
      'Boutique-Ferienhäuser',
      'Langfristige Anlageimmobilie'
    ]
  },
  he: {
    title: 'שימושים אפשריים',
    uses: [
      'בית נופש פרטי',
      'מקלט משפחתי לקיץ',
      'קוטג\'ים להשכרה בוטיק',
      'נכס השקעה ארוך טווח'
    ]
  },
  fr: {
    title: 'Utilisations Potentielles',
    uses: [
      'Résidence de vacances privée',
      'Retraite familiale d\'été',
      'Cottages de location boutique',
      'Propriété d\'investissement à long terme'
    ]
  },
  zh: {
    title: '潜在用途',
    uses: [
      '私人度假住宅',
      '家庭夏季度假屋',
      '精品出租小屋',
      '长期投资物业'
    ]
  },
  ar: {
    title: 'الاستخدامات المحتملة',
    uses: [
      'مقر إقامة عطلة خاص',
      'ملاذ صيفي عائلي',
      'أكواخ إيجار بوتيك',
      'عقار استثماري طويل الأجل'
    ]
  },
  ru: {
    title: 'Возможные Варианты Использования',
    uses: [
      'Частная резиденция для отдыха',
      'Семейный летний дом',
      'Бутик-коттеджи для аренды',
      'Долгосрочная инвестиционная недвижимость'
    ]
  }
};

export const faqData = {
  en: {
    title: 'Quick FAQ',
    questions: [
      {
        q: 'Is the property legally clear?',
        a: 'The offering combines two adjoining properties presented as a single residence. One property is held in full (100%) ownership, while the second is held under majority ownership (2/3 share), both lawfully acquired and registered. Ownership derives from a clear notarial title history, with no issues affecting use or transfer. Full documentation is available for buyer due diligence.'
      },
      {
        q: 'Are the cottages independent?',
        a: 'Yes, both cottages are fully independent with separate entrances and utilities.'
      },
      {
        q: 'Is the land private and single plot?',
        a: 'The properties are situated on a private, legally defined plot, forming a single registered land parcel. Land ownership follows the recorded title structure and is fully documented, with no issues affecting use or transfer.'
      },
      {
        q: 'Can a viewing be arranged?',
        a: 'Yes, viewings can be arranged at your convenience. Please contact us to schedule.'
      },
      {
        q: 'Why is the property presented as one residence?',
        a: 'The two adjoining properties have long been used and function as a single, unified home, which is how they are presented today.'
      },
      {
        q: 'Is ownership straightforward for a buyer?',
        a: 'Yes. One property is held in full ownership, and the second under majority ownership, both with full legal rights. All details are fully documented.'
      },
      {
        q: 'Is the land private and clearly defined?',
        a: 'Yes. The residence stands on a private, legally defined plot recorded as a single land parcel.'
      },
      {
        q: 'Will full legal documentation be provided?',
        a: 'Absolutely. All notarial deeds and registrations are available for complete due diligence.'
      }
    ]
  },
  gr: {
    title: 'Συχνές Ερωτήσεις',
    questions: [
      {
        q: 'Είναι το ακίνητο νομικά καθαρό;',
        a: 'Η προσφορά συνδυάζει δύο γειτονικές ιδιοκτησίες που παρουσιάζονται ως ενιαία κατοικία. Η μία ιδιοκτησία κατέχεται πλήρως (100%), ενώ η δεύτερη κατέχεται κατά πλειοψηφία (μερίδιο 2/3), και οι δύο νόμιμα αποκτηθείσες και καταχωρημένες. Η κυριότητα προέρχεται από σαφές ιστορικό συμβολαιογραφικών τίτλων, χωρίς ζητήματα που επηρεάζουν τη χρήση ή τη μεταβίβαση. Πλήρης τεκμηρίωση διατίθεται για τον έλεγχο του αγοραστή.'
      },
      {
        q: 'Είναι τα εξοχικά ανεξάρτητα;',
        a: 'Ναι, και τα δύο εξοχικά είναι πλήρως ανεξάρτητα με ξεχωριστές εισόδους και παροχές.'
      },
      {
        q: 'Είναι η γη ιδιωτική και ενιαίο οικόπεδο;',
        a: 'Οι ιδιοκτησίες βρίσκονται σε ιδιωτικό, νομικά καθορισμένο οικόπεδο, που αποτελεί ενιαίο καταγεγραμμένο γεωτεμάχιο. Η κυριότητα της γης ακολουθεί την καταγεγραμμένη δομή τίτλου και είναι πλήρως τεκμηριωμένη, χωρίς ζητήματα που επηρεάζουν τη χρήση ή τη μεταβίβαση.'
      },
      {
        q: 'Μπορεί να κανονιστεί επίσκεψη;',
        a: 'Ναι, οι επισκέψεις μπορούν να κανονιστούν κατά τη διάθεσή σας. Επικοινωνήστε μαζί μας.'
      },
      {
        q: 'Γιατί παρουσιάζεται το ακίνητο ως μία κατοικία;',
        a: 'Οι δύο γειτονικές ιδιοκτησίες χρησιμοποιούνται εδώ και καιρό και λειτουργούν ως ενιαία κατοικία, όπως παρουσιάζονται σήμερα.'
      },
      {
        q: 'Είναι η ιδιοκτησία απλή για έναν αγοραστή;',
        a: 'Ναι. Η μία ιδιοκτησία κατέχεται πλήρως και η δεύτερη κατά πλειοψηφία, και οι δύο με πλήρη νομικά δικαιώματα. Όλες οι λεπτομέρειες είναι πλήρως τεκμηριωμένες.'
      },
      {
        q: 'Είναι η γη ιδιωτική και σαφώς καθορισμένη;',
        a: 'Ναι. Η κατοικία βρίσκεται σε ιδιωτικό, νομικά καθορισμένο οικόπεδο καταγεγραμμένο ως ενιαίο γεωτεμάχιο.'
      },
      {
        q: 'Θα παρασχεθεί πλήρης νομική τεκμηρίωση;',
        a: 'Απολύτως. Όλα τα συμβολαιογραφικά έγγραφα και οι καταχωρήσεις είναι διαθέσιμα για πλήρη έλεγχο.'
      }
    ]
  },
  de: {
    title: 'Häufig Gestellte Fragen',
    questions: [
      {
        q: 'Ist die Immobilie rechtlich einwandfrei?',
        a: 'Das Angebot kombiniert zwei angrenzende Immobilien, die als eine Residenz präsentiert werden. Eine Immobilie befindet sich im Vollbesitz (100%), während die zweite im Mehrheitsbesitz (2/3 Anteil) gehalten wird, beide rechtmäßig erworben und registriert. Das Eigentum leitet sich aus einer klaren notariellen Titelhistorie ab, ohne Probleme, die die Nutzung oder Übertragung beeinträchtigen. Vollständige Dokumentation ist für die Käuferprüfung verfügbar.'
      },
      {
        q: 'Sind die Cottages unabhängig?',
        a: 'Ja, beide Cottages sind völlig unabhängig mit separaten Eingängen und Versorgungseinrichtungen.'
      },
      {
        q: 'Ist das Land privat und ein einzelnes Grundstück?',
        a: 'Die Immobilien befinden sich auf einem privaten, rechtlich definierten Grundstück, das ein einzelnes registriertes Grundstück bildet. Das Landeigentum folgt der aufgezeichneten Titelstruktur und ist vollständig dokumentiert, ohne Probleme, die die Nutzung oder Übertragung beeinträchtigen.'
      },
      {
        q: 'Kann eine Besichtigung arrangiert werden?',
        a: 'Ja, Besichtigungen können nach Ihrer Verfügbarkeit arrangiert werden. Bitte kontaktieren Sie uns.'
      },
      {
        q: 'Warum wird die Immobilie als eine Residenz präsentiert?',
        a: 'Die zwei angrenzenden Immobilien werden seit langem genutzt und funktionieren als ein einheitliches Zuhause, so wie sie heute präsentiert werden.'
      },
      {
        q: 'Ist das Eigentum für einen Käufer unkompliziert?',
        a: 'Ja. Eine Immobilie befindet sich im Vollbesitz und die zweite im Mehrheitsbesitz, beide mit vollen Rechten. Alle Details sind vollständig dokumentiert.'
      },
      {
        q: 'Ist das Land privat und klar definiert?',
        a: 'Ja. Die Residenz steht auf einem privaten, rechtlich definierten Grundstück, das als einzelnes Grundstück registriert ist.'
      },
      {
        q: 'Wird vollständige rechtliche Dokumentation bereitgestellt?',
        a: 'Absolut. Alle notariellen Urkunden und Registrierungen sind für eine vollständige Prüfung verfügbar.'
      }
    ]
  },
  he: {
    title: 'שאלות נפוצות',
    questions: [
      {
        q: 'האם הנכס חוקי ונקי?',
        a: 'ההצעה משלבת שני נכסים סמוכים המוצגים כמגורים אחד. נכס אחד מוחזק בבעלות מלאה (100%), בעוד השני מוחזק בבעלות רוב (2/3), שניהם נרכשו ונרשמו כחוק. הבעלות נובעת מהיסטוריית שטרות נוטריונית ברורה, ללא בעיות המשפיעות על השימוש או ההעברה. תיעוד מלא זמין לבדיקת נאותות.'
      },
      {
        q: 'האם הקוטג\'ים עצמאיים?',
        a: 'כן, שני הקוטג\'ים עצמאיים לחלוטין עם כניסות ותשתיות נפרדות.'
      },
      {
        q: 'האם הקרקע פרטית ומגרש יחיד?',
        a: 'הנכסים ממוקמים על מגרש פרטי מוגדר חוקית, המהווה חלקת קרקע רשומה אחת. בעלות הקרקע עוקבת אחר מבנה הבעלות הרשום ומתועדת במלואה, ללא בעיות המשפיעות על השימוש או ההעברה.'
      },
      {
        q: 'האם ניתן לתאם ביקור?',
        a: 'כן, ניתן לתאם ביקורים בהתאם לנוחיותכם. אנא צרו קשר.'
      },
      {
        q: 'מדוע הנכס מוצג כמגורים אחד?',
        a: 'שני הנכסים הסמוכים שימשו זמן רב ומתפקדים כבית מאוחד אחד, כפי שהם מוצגים היום.'
      },
      {
        q: 'האם הבעלות פשוטה לקונה?',
        a: 'כן. נכס אחד מוחזק בבעלות מלאה והשני בבעלות רוב, שניהם עם זכויות משפטיות מלאות. כל הפרטים מתועדים במלואם.'
      },
      {
        q: 'האם הקרקע פרטית ומוגדרת בבירור?',
        a: 'כן. המגורים עומדים על מגרש פרטי מוגדר חוקית הרשום כחלקת קרקע אחת.'
      },
      {
        q: 'האם יסופק תיעוד משפטי מלא?',
        a: 'בהחלט. כל השטרות הנוטריוניים והרישומים זמינים לבדיקת נאותות מלאה.'
      }
    ]
  },
  fr: {
    title: 'FAQ Rapide',
    questions: [
      {
        q: 'La propriété est-elle légalement claire?',
        a: 'L\'offre combine deux propriétés adjacentes présentées comme une seule résidence. Une propriété est détenue en pleine propriété (100%), tandis que la seconde est détenue en propriété majoritaire (2/3), toutes deux légalement acquises et enregistrées. La propriété découle d\'un historique de titre notarié clair, sans problèmes affectant l\'utilisation ou le transfert. Une documentation complète est disponible pour la diligence raisonnable.'
      },
      {
        q: 'Les cottages sont-ils indépendants?',
        a: 'Oui, les deux cottages sont entièrement indépendants avec des entrées et des services séparés.'
      },
      {
        q: 'Le terrain est-il privé et parcelle unique?',
        a: 'Les propriétés sont situées sur un terrain privé légalement défini, formant une parcelle cadastrale unique. La propriété foncière suit la structure de titre enregistrée et est entièrement documentée, sans problèmes affectant l\'utilisation ou le transfert.'
      },
      {
        q: 'Une visite peut-elle être organisée?',
        a: 'Oui, les visites peuvent être organisées à votre convenance. Veuillez nous contacter.'
      },
      {
        q: 'Pourquoi la propriété est-elle présentée comme une seule résidence?',
        a: 'Les deux propriétés adjacentes sont utilisées depuis longtemps et fonctionnent comme une maison unifiée, c\'est ainsi qu\'elles sont présentées aujourd\'hui.'
      },
      {
        q: 'La propriété est-elle simple pour un acheteur?',
        a: 'Oui. Une propriété est détenue en pleine propriété et la seconde en propriété majoritaire, toutes deux avec tous les droits légaux. Tous les détails sont entièrement documentés.'
      },
      {
        q: 'Le terrain est-il privé et clairement défini?',
        a: 'Oui. La résidence se trouve sur un terrain privé légalement défini enregistré comme parcelle unique.'
      },
      {
        q: 'Une documentation juridique complète sera-t-elle fournie?',
        a: 'Absolument. Tous les actes notariés et enregistrements sont disponibles pour une diligence raisonnable complète.'
      }
    ]
  },
  zh: {
    title: '常见问题',
    questions: [
      {
        q: '房产法律手续是否齐全？',
        a: '此房产由两处相邻物业组成，作为单一住宅出售。一处物业为完全所有权（100%），另一处为多数所有权（2/3份额），均合法取得并登记。产权来自清晰的公证历史，不存在影响使用或转让的问题。完整文件可供买方尽职调查。'
      },
      {
        q: '小屋是否独立？',
        a: '是的，两栋小屋完全独立，有单独的入口和设施。'
      },
      {
        q: '土地是否为私人单一地块？',
        a: '物业位于私人、合法界定的地块上，构成单一登记地块。土地所有权遵循登记的产权结构，文件齐全，不存在影响使用或转让的问题。'
      },
      {
        q: '可以安排看房吗？',
        a: '是的，可以根据您的时间安排看房。请联系我们预约。'
      },
      {
        q: '为什么房产作为单一住宅出售？',
        a: '这两处相邻物业长期以来一直作为统一的住宅使用和运作，这也是今天展示的方式。'
      },
      {
        q: '买家的所有权是否简单明了？',
        a: '是的。一处物业为完全所有权，另一处为多数所有权，均享有完整法律权利。所有细节均有完整文件记录。'
      },
      {
        q: '土地是否为私人且界定清晰？',
        a: '是的。住宅位于私人、合法界定的地块上，登记为单一地块。'
      },
      {
        q: '是否会提供完整的法律文件？',
        a: '当然。所有公证契约和登记文件均可供完整尽职调查。'
      }
    ]
  },
  ar: {
    title: 'أسئلة شائعة',
    questions: [
      {
        q: 'هل العقار واضح قانونياً؟',
        a: 'يجمع العرض بين عقارين متجاورين يُقدمان كمسكن واحد. عقار واحد مملوك بالكامل (100%)، بينما الثاني مملوك بملكية أغلبية (حصة 2/3)، كلاهما مكتسب ومسجل قانونياً. الملكية مستمدة من تاريخ سند توثيقي واضح، دون أي مشاكل تؤثر على الاستخدام أو النقل. الوثائق الكاملة متاحة لفحص المشتري.'
      },
      {
        q: 'هل الأكواخ مستقلة؟',
        a: 'نعم، كلا الكوخين مستقلان تماماً مع مداخل ومرافق منفصلة.'
      },
      {
        q: 'هل الأرض خاصة وقطعة واحدة؟',
        a: 'تقع العقارات على قطعة أرض خاصة محددة قانونياً، تشكل قطعة أرض مسجلة واحدة. ملكية الأرض تتبع هيكل الملكية المسجل وموثقة بالكامل، دون مشاكل تؤثر على الاستخدام أو النقل.'
      },
      {
        q: 'هل يمكن ترتيب زيارة؟',
        a: 'نعم، يمكن ترتيب الزيارات حسب راحتك. يرجى الاتصال بنا للجدولة.'
      },
      {
        q: 'لماذا يُقدم العقار كمسكن واحد؟',
        a: 'العقاران المتجاوران استُخدما لفترة طويلة ويعملان كمنزل موحد واحد، وهذه هي الطريقة التي يُقدمان بها اليوم.'
      },
      {
        q: 'هل الملكية بسيطة للمشتري؟',
        a: 'نعم. عقار واحد مملوك بالكامل والثاني بملكية أغلبية، كلاهما بحقوق قانونية كاملة. جميع التفاصيل موثقة بالكامل.'
      },
      {
        q: 'هل الأرض خاصة ومحددة بوضوح؟',
        a: 'نعم. المسكن يقع على قطعة أرض خاصة محددة قانونياً مسجلة كقطعة أرض واحدة.'
      },
      {
        q: 'هل سيتم توفير وثائق قانونية كاملة؟',
        a: 'بالتأكيد. جميع الصكوك التوثيقية والتسجيلات متاحة للفحص الكامل.'
      }
    ]
  },
  ru: {
    title: 'Часто Задаваемые Вопросы',
    questions: [
      {
        q: 'Юридически ли чист объект?',
        a: 'Предложение объединяет два смежных объекта, представленных как единая резиденция. Один объект находится в полной собственности (100%), второй — в мажоритарной собственности (доля 2/3), оба законно приобретены и зарегистрированы. Право собственности происходит из четкой нотариальной истории, без проблем, влияющих на использование или передачу. Полная документация доступна для проверки покупателем.'
      },
      {
        q: 'Являются ли коттеджи независимыми?',
        a: 'Да, оба коттеджа полностью независимы с отдельными входами и коммуникациями.'
      },
      {
        q: 'Является ли земля частной и единым участком?',
        a: 'Объекты расположены на частном, юридически определенном участке, образующем единый зарегистрированный земельный участок. Право собственности на землю следует зарегистрированной структуре и полностью документировано, без проблем, влияющих на использование или передачу.'
      },
      {
        q: 'Можно ли организовать просмотр?',
        a: 'Да, просмотры могут быть организованы в удобное для вас время. Свяжитесь с нами.'
      },
      {
        q: 'Почему объект представлен как единая резиденция?',
        a: 'Два смежных объекта долгое время использовались и функционируют как единый дом, именно так они представлены сегодня.'
      },
      {
        q: 'Просто ли оформить собственность для покупателя?',
        a: 'Да. Один объект находится в полной собственности, второй — в мажоритарной, оба с полными юридическими правами. Все детали полностью документированы.'
      },
      {
        q: 'Является ли земля частной и четко определенной?',
        a: 'Да. Резиденция расположена на частном, юридически определенном участке, зарегистрированном как единый земельный участок.'
      },
      {
        q: 'Будет ли предоставлена полная юридическая документация?',
        a: 'Безусловно. Все нотариальные акты и регистрации доступны для полной проверки.'
      }
    ]
  }
};

export const ctaButtons = {
  en: {
    requestDetails: 'Request Full Details',
    arrangeViewing: 'Arrange a Viewing',
    downloadBrochure: 'Download PDF Brochure'
  },
  gr: {
    requestDetails: 'Ζητήστε Πλήρη Στοιχεία',
    arrangeViewing: 'Κλείστε Επίσκεψη',
    downloadBrochure: 'Κατεβάστε PDF Έντυπο'
  },
  de: {
    requestDetails: 'Vollständige Details anfordern',
    arrangeViewing: 'Besichtigung vereinbaren',
    downloadBrochure: 'PDF-Broschüre herunterladen'
  },
  he: {
    requestDetails: 'בקש פרטים מלאים',
    arrangeViewing: 'תאם ביקור',
    downloadBrochure: 'הורד חוברת PDF'
  },
  fr: {
    requestDetails: 'Demander les détails complets',
    arrangeViewing: 'Organiser une visite',
    downloadBrochure: 'Télécharger la brochure PDF'
  },
  zh: {
    requestDetails: '索取完整详情',
    arrangeViewing: '安排看房',
    downloadBrochure: '下载PDF手册'
  },
  ar: {
    requestDetails: 'طلب التفاصيل الكاملة',
    arrangeViewing: 'ترتيب زيارة',
    downloadBrochure: 'تحميل كتيب PDF'
  },
  ru: {
    requestDetails: 'Запросить полные детали',
    arrangeViewing: 'Организовать просмотр',
    downloadBrochure: 'Скачать PDF-брошюру'
  }
};